import { format, isValid } from 'date-fns'
import {
  momentPreviewHeaderCellHeadingStyles,
  momentPreviewHeaderCellTextStyles,
  momentPreviewHeaderStyles,
  momentPreviewHeaderUlStyles,
} from './styles'

interface Props {
  dueDate?: string
  stageName: string
  storyName?: string
}

export const dateDisplayFormat = 'MMM dd, yyyy'
export const optionalTextPlaceholder = '-'

export const MomentPreviewHeader: React.FC<Props> = ({
  dueDate = optionalTextPlaceholder,
  stageName,
  storyName = optionalTextPlaceholder,
}) => {
  const getFormattedDate = (): string => {
    const date = new Date(dueDate)
    const validDate = isValid(date)
    if (!validDate) {
      return optionalTextPlaceholder
    }
    return format(date, dateDisplayFormat)
  }

  return (
    <header css={momentPreviewHeaderStyles}>
      <ul css={momentPreviewHeaderUlStyles}>
        <li>
          <div css={momentPreviewHeaderCellHeadingStyles}>Story</div>
          <div css={momentPreviewHeaderCellTextStyles}>{storyName}</div>
        </li>
        <li>
          <div css={momentPreviewHeaderCellHeadingStyles}>Phase</div>
          <div css={momentPreviewHeaderCellTextStyles}>{stageName}</div>
        </li>
        <li>
          <div css={momentPreviewHeaderCellHeadingStyles}>Due Date</div>
          <div css={momentPreviewHeaderCellTextStyles}>
            {getFormattedDate()}
          </div>
        </li>
      </ul>
    </header>
  )
}
